module.exports = __webpack_public_path__ + "img/table-sorting.88c4688b.svg";